export default __webpack_public_path__ + "static/media/3079.029724d4.jpg";